function getBazaarProductReviews(bazaarVoiceId) {
  return fetch(
    `https://api.bazaarvoice.com/data/reviews.json?apiversion=5.4&passkey=drvgwonih7es3o3b0v3g0f9m4&Filter=ProductId:${bazaarVoiceId}&Include=Products&Stats=Reviews&Limit=7`
  );
}

export default getBazaarProductReviews;
